import React, { Component } from "react";
import logoWhite from '../../assets/image/propaganda-logo-white.png'
import Footer from "../Layout/Footer"
import MetaTags from 'react-meta-tags'


class HomePage extends Component {


	randomDelay = () => {
		let numbers = ['1000', '1500', '2000', '2500', '3000', '3500']
		var delay = numbers[(Math.random() * numbers.length) | 0]
		return delay
	}

  componentDidMount() {
    var jquery = '/js/custom.js'
    var addScript = document.createElement('script');
    addScript.setAttribute('src', jquery );
	document.body.appendChild(addScript);
	document.body.removeChild(addScript);
  }

 
  render() {

    return (
		<div className="home-page">
		   <MetaTags>
            <title>Propaganda Web and App Developing</title>
            <meta name="description" content="Propaganda Web and App Developing" />
            <meta property="og:title" content="Propaganda Web and App Developing " />
            <meta property="og:image" content="https://propaganda.world/img/the-best-list-app.jpg" />
            <meta property="og:description" content="Website & Mobile App Development, we develop clean and sharp digital products and prototypes for companies, startups and individuals" />
        </MetaTags>
			<div id="index-banner" className="parallax-container  parallax-container-auto lg-black">				
				<div className="container center middle">
					<img src={logoWhite} className="img-width-300" alt="Unsplashed background img 1" 
							data-aos="fade-in"
                            data-aos-offset="100"
                            data-aos-delay="0"
                            data-aos-duration="3000"
                            data-aos-easing="ease-in-out"
                            data-aos-mirror="true"
                            data-aos-once="false"
                            data-aos-anchor-placement="top-center"
					/>
                    <h1 className="header center white-text capital tiny"
							data-aos="fade-in"
                            data-aos-offset="0"
                            data-aos-delay="0"
                            data-aos-duration="3000"
                            data-aos-easing="ease-in-out"
                            data-aos-mirror="true"
                            data-aos-once="false"
                            data-aos-anchor-placement="top-center"
					
					>we are creating</h1>
					<h1 className="header center white-text capital tiny"
							data-aos="fade-in"
                            data-aos-offset="-100"
                            data-aos-delay="1000"
                            data-aos-duration="3000"
                            data-aos-easing="ease-in-out"
                            data-aos-mirror="true"
                            data-aos-once="false"
                            data-aos-anchor-placement="top-center"
					>websites & apps</h1>
				</div>
			</div>

			<div className="container center mgt96">
				<div className="row  mgt48 mgb48">
					<h2 className="center m-24 mgt24 upercase tiny">Internet is our playground</h2> 

					<p className="subtitle">we like to play with:</p>

				</div>    
			</div>
			<div id="index-banner" className="parallax-container parallax-container-auto">
				<div className="container col s12 white-text">
					<div className="row">
						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
								<h2 className="center">
									<i className="fab fa-php"></i>
								</h2>
							</div>
						</div>

						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay="0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							<h2 className="center">
									<i className="fab fa-js"></i>
								</h2>
							</div>
						</div>

						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"							
							>
							    <h2 className="center">
									<i className="fab fa-html5"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-css3-alt"></i>
								</h2>
							</div>
						</div>

						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-react"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-wordpress"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center" 
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-joomla"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-node"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-npm"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
							
							    data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-node-js"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
								data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-sass"></i>
								</h2>
							</div>
						</div>
						<div className="col s6 m3">
							<div className="icon-block center"
							    data-aos="fade-in"
								data-aos-offset="-200"
								data-aos-delay= "0"
								data-aos-duration={this.randomDelay()}
								data-aos-easing="ease-in-out"
								data-aos-mirror="true"
								data-aos-once="false"
								data-aos-anchor-placement="top-center"
							>
							    <h2 className="center">
									<i className="fab fa-bitbucket"></i>
								</h2>
							</div>
						</div>
					</div>
				</div>
		    </div>
			<div className="section dark-blue">
				<div className="container">
					<div className="row center">
						<h3 className="black-text mgb48 tiny">Start Your New Web Campaign</h3>
						<a href="mailto:support@propaganda.world" id="download-button" className="btn-large waves-effect waves-light red darken-4">Contact Us</a>
				    </div>
				</div>
			</div>


		     <Footer />
		</div>
    );
  }
}

export default HomePage;